import PptxGenJS from "pptxgenjs";

export type Rater = { review_type: string; avg_score: number; rater_count: number; variance: number; };
export const calculateGlobalNorm = (raters: Rater[]): number => {
    let totalScore = 0;
    let totalCount = 0;
    for (const rater of raters) {
        totalScore += rater.avg_score * rater.rater_count;
        totalCount += rater.rater_count;
    }
    if (totalCount === 0) {
        return 0;
    }
    return totalScore / totalCount;
}

export const slide2 = (pptx: PptxGenJS, data: any) => {
    const slide = pptx.addSlide();
    const reportData = data?.data
    // Logo
    slide.addImage({
        path: '/Access-Holdings-Logo.jpg',
        x: 0.5,
        y: 0.2,
        w: 1.3,
        h: 0.45
    });

    // Title
    slide.addText("Your 360-Degree Feedback Snapshot- Executor Domain", {
        x: 0.5,
        y: 0.8,
        w: 7.27,
        h: 0.5,
        fontSize: 18,
        bold: true,
        color: '000000'
    });

    // Description
    const description = "This report focuses on the Executor domain of the RBL Leadership code.\n\nThe Executors keep the near-term perspective on the organization in the competitive landscape at the forefront.\n\nThey enjoy living in the concrete and actionable world of execution and are clear and decisive in getting things done through the people in their organization. They set clear priorities and accountability, and get things done.";
    slide.addText(description, {
        x: 0.5,
        y: 1.3,
        w: 7.27,
        h: 1.5,
        fontSize: 10,
        color: '595959'
    });

    // Score at a Glance Section
    slide.addText("Score at a Glance", {
        x: 0.5,
        y: 3.1,
        w: 7.27,
        h: 0.3,
        fontSize: 14,
        bold: true,
        color: '000000'
    });

    // Helper for Progress Bar
    const addProgressBar = (s: any, x: number, y: number, w: number, score: number, globalNorm: number) => {
        const barHeight = 0.15;
        const scale = 5;
        const orangeWidth = (Math.min(score, scale) / scale) * w;
        const normPos = (Math.min(globalNorm, scale) / scale) * w;

        // Background bar
        s.addShape('rect', {
            x: x, y: y, w: w, h: barHeight,
            fill: { color: 'F0F0F0' },
            line: { type: 'none' }
        });

        // Orange progress
        s.addShape('rect', {
            x: x, y: y, w: orangeWidth, h: barHeight,
            fill: { color: 'FF6600' },
            line: { type: 'none' }
        });

        // Global Norm tick
        s.addShape('rect', {
            x: x + normPos, y: y - 0.05, w: 0.03, h: barHeight + 0.1,
            fill: { color: '404040' },
            line: { type: 'none' }
        });
    };

    // Table 1: Score at a Glance
    slide.addShape('rect', { x: 0.5, y: 3.4, w: 7.27, h: 0.8, line: { color: '404040', width: 1 } });
    slide.addShape('rect', { x: 0.5, y: 3.4, w: 7.27, h: 0.4, fill: { color: 'F8F8F8' }, line: { color: '404040', width: 1 } });

    // Headers
    const headers = ["Results", "YOUR SCORE", "GLOBAL NORM"];
    const headerX = [0.6, 2.3, 3.2];
    headers.forEach((h, i) => {
        slide.addText(h, { x: headerX[i], y: 3.45, w: 1, h: 0.3, fontSize: 10, bold: true, align: 'center' });
    });

    const yourScore = reportData?.participantReport?.averageScore ? (reportData?.participantReport?.averageScore).toFixed(2) : '0'
    const globalNorm = reportData?.participantReport?.globalNormAvg ? (reportData?.participantReport?.globalNormAvg).toFixed(2) : '0'
    // Rows
    slide.addText("Executor", { x: 0.6, y: 3.85, w: 1, h: 0.3, fontSize: 11, bold: true });
    slide.addText(
        `${yourScore}`,
        { x: 2.5, y: 3.85, w: 1, h: 0.3, fontSize: 12, bold: true, color: 'FF6600', align: 'center' });
    slide.addText(`${globalNorm}`, { x: 3.2, y: 3.85, w: 1, h: 0.3, fontSize: 12, bold: true, align: 'center' });
    addProgressBar(slide, 4.3, 3.92, 3.2, parseFloat(yourScore), parseFloat(globalNorm));

    // Executor Detail 
    slide.addShape('rect', { x: 0.6, y: 4.5, w: 7.1, h: 1.0, line: { color: '404040', width: 1 } });
    slide.addText("Executor", { x: 0.7, y: 4.6, w: 1.5, h: 0.3, fontSize: 13, bold: true });

    // Your Score 
    slide.addShape('rect', { x: 2.0, y: 4.75, w: 0.8, h: 0.6, fill: { color: 'FFFFFF' }, line: { color: 'E0E0E0', width: 1 } });
    slide.addText("YOUR SCORE", { x: 2.0, y: 4.8, w: 0.8, h: 0.1, fontSize: 6, align: 'center' });
    slide.addText(`${yourScore}`, { x: 2.0, y: 4.9, w: 0.8, h: 0.3, fontSize: 14, bold: true, color: 'FF6600', align: 'center' });

    // Global Norm 
    slide.addShape('rect', { x: 3.0, y: 4.75, w: 0.8, h: 0.6, fill: { color: 'FFFFFF' }, line: { color: 'E0E0E0', width: 1 } });
    slide.addText("GLOBAL NORM", { x: 3.0, y: 4.8, w: 0.8, h: 0.1, fontSize: 6, align: 'center' });
    slide.addText(`${globalNorm}`, { x: 3.0, y: 4.9, w: 0.8, h: 0.3, fontSize: 14, bold: true, align: 'center' });

    const detailBarW = 3.0;
    const detailBarX = 4.5;
    const detailBarY = 4.8;
    const orangeWidth = (Math.min(parseFloat(yourScore), 5) / 5) * detailBarW;
    const blackWidth = (Math.min(parseFloat(globalNorm), 5) / 5) * detailBarW;
    const normPos = (Math.min(parseFloat(globalNorm), 5) / 5) * detailBarW;
    slide.addShape('rect', { x: detailBarX, y: detailBarY, w: orangeWidth, h: 0.2, fill: { color: 'FF6600' } });
    slide.addShape('rect', { x: detailBarX, y: detailBarY + 0.2, w: blackWidth, h: 0.2, fill: { color: '000000' } });
    //slide.addShape('rect', { x: detailBarX + normPos, y: detailBarY - 0.05, w: 0.03, h: 0.1, fill: { color: '404040' } });

    // Scale numbers
    [0, 1, 2, 3, 4, 5].forEach(num => {
        slide.addText(num.toString(), { x: detailBarX + (num / 5 * detailBarW) - 0.05, y: detailBarY + 0.45, w: 0.1, h: 0.1, fontSize: 7, color: '808080' });
    });

    // Competency Table
    const compTop = 5.8;
    slide.addShape('rect', { x: 0.6, y: compTop, w: 7.1, h: 1.2, line: { color: '404040', width: 1 } });
    slide.addShape('rect', { x: 0.6, y: compTop, w: 7.1, h: 0.2, fill: { color: 'F8F8F8' }, line: { color: '404040' } });

    const compHeaders = ["Competency", "Your Score", "Global Norm", "Comparison"];
    const compX = [0.7, 3.2, 3.8, 4.4];
    compHeaders.forEach((h, i) => {
        slide.addText(h, { x: compX[i], y: compTop, w: 1, h: 0.2, fontSize: 7, bold: true });
    });

    const labels = ['A', 'B', 'C', 'D', 'E']
    const competencies: { label: string, name: string, score: number, norm: number }[] = reportData?.participantReport?.combinedScores?.map((c: any, i: number) => {
        return {
            label: labels[i],
            name: c?.tag,
            score: c?.my_score,
            norm: c?.global_norm
        }
    })

    competencies.forEach((c, i) => {
        const rowY = compTop + 0.2 + (i * 0.2);
        // Orange circle label
        slide.addShape('rect', { x: 0.7, y: rowY + 0.03, w: 0.12, h: 0.12, fill: { color: 'FF6600' }, line: { type: 'none' } }); // Placeholder for circle
        slide.addText(c.label, { x: 0.7, y: rowY, w: 0.12, h: 0.2, fontSize: 7, color: 'FFFFFF', bold: true, align: 'center' });

        slide.addText(c.name, { x: 0.9, y: rowY, w: 2.2, h: 0.2, fontSize: 8, color: '404040' });
        slide.addText(c.score.toFixed(1), { x: 3.2, y: rowY, w: 0.5, h: 0.2, fontSize: 9, bold: true, color: 'FF6600' });
        slide.addText(c.norm.toFixed(1), { x: 3.8, y: rowY, w: 0.5, h: 0.2, fontSize: 9, color: '404040' });
        addProgressBar(slide, 4.4, rowY + 0.05, 3.2, c.score, c.norm);
    });

    // Your Top Strengths Section
    slide.addText("Your Top Strengths (Top 3 behaviours with the highest scores)", {
        x: 0.6,
        y: 7.2,
        w: 7.27,
        h: 0.3,
        fontSize: 14,
        bold: true,
        color: '000000'
    });

    const strengthTop = 7.5;
    slide.addShape('rect', { x: 0.5, y: strengthTop, w: 7.27, h: 2.5, line: { color: '404040', width: 1 } });
    slide.addShape('rect', { x: 0.5, y: strengthTop, w: 7.27, h: 0.5, fill: { color: 'EAEAEA' }, line: { color: '404040', width: 1 } });

    // Strength Headers
    const stHeaders = ["Key Strengths", "YOUR SCORE", "GLOBAL NORM"];
    const stX = [0.6, 3.2, 4.0];
    stHeaders.forEach((h, i) => {
        slide.addText(h, { x: stX[i], y: strengthTop + 0.1, w: 1.5, h: 0.3, fontSize: 10, bold: true });
    });

    const rawStrengths = reportData?.participantReport?.combinedQuestions?.length ?
        reportData?.participantReport?.combinedQuestions
        : []
    const strengths: { text: string; score: number; norm: number }[] =
        rawStrengths
            ?.sort((a: any, b: any) => {
                const aScore = a?.my_score ?? null;
                const bScore = b?.my_score ?? null;
                if (aScore === null && bScore === null) return 0;
                if (aScore === null) return 1;
                if (bScore === null) return -1;
                return bScore - aScore;
            })
            ?.slice(0, 3)
            ?.map((q: any) => {
                return {
                    text: q?.text,
                    score: q?.my_score,
                    norm: calculateGlobalNorm(q?.raters),
                };
            });

    strengths.forEach((st, i) => {
        const rowY = strengthTop + 0.5 + (i * 0.65);
        slide.addShape('rect', { x: 0.5, y: rowY, w: 7.27, h: 0.65, line: { color: '404040', width: 0.5 } });
        slide.addText(st.text, { x: 0.6, y: rowY, w: 2.5, h: 0.6, fontSize: 9, color: '404040', valign: 'middle' });
        slide.addText(st.score.toFixed(2), { x: 3.2, y: rowY, w: 0.7, h: 0.6, fontSize: 11, bold: true, color: 'FF6600', align: 'center', valign: 'middle' });
        slide.addText(st.norm.toFixed(2), { x: 4.0, y: rowY, w: 0.7, h: 0.6, fontSize: 11, bold: true, align: 'center', valign: 'middle' });
        addProgressBar(slide, 4.8, rowY + 0.25, 2.8, st.score, st.norm);
    });

    // Footer
    const candidateName = data?.candidateName || 'Jane Doe';
    slide.addText(`360-Degree Feedback Individual Report for ${candidateName}`, {
        x: 0,
        y: 11.2,
        w: 7.8,
        h: 0.3,
        fontSize: 9,
        color: '666666',
        align: 'center'
    });

    // slide.addText("3", {
    //     x: 7.8,
    //     y: 11.2,
    //     w: 0.4,
    //     h: 0.3,
    //     fontSize: 9,
    //     color: '666666',
    //     align: 'center'
    // });
};
